import { useMutation } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type UpdateHServiceBody = Parameters<typeof apiClient.v2.apiHserviceElUpdate>[0]

const updateHService = async (body: UpdateHServiceBody) => {
  const { data } = await apiClient.v2.apiHserviceElUpdate(body)
  return checkApiResponse(data)
}

export const useHServiceUpdateMutation = ({ options }: MutationComposableParams<unknown, UpdateHServiceBody> = {}) => {
  return useMutation(() => ({
    mutationFn: updateHService,
    ...resolveMaybeGetter(options ?? {}),
  }))
}
